// extracted by mini-css-extract-plugin
module.exports = {"postLinkBox":"PostLink-module--postLinkBox--3HhnL","date":"PostLink-module--date--8kSZc"};